import { CaptionBlockProps } from './type';

interface Props {
  blockProps: CaptionBlockProps;
  scaleFactor?: number;
  maxWidth: number;
}

export const CaptionBlock: React.FC<Props> = (props) => {
  const { blockProps, maxWidth, scaleFactor = 1 } = props;
  const {
    value,
    isBold,
    isItalics,
    fontSize,
    width,
    isCapsLocks,
    color,
    backgroundColor,
  } = blockProps;
  // Enables spaces and newline in the value
  // eslint-disable-next-line no-regex-spaces
  const formattedValue = value
    .replace(/\n/g, '<br />')
    .replace(/  /g, '&nbsp;&nbsp;');

  return (
    <div
      style={{
        maxWidth: maxWidth * scaleFactor,
        fontSize: `${fontSize * scaleFactor}px`,
        fontWeight: isBold ? '600' : 'normal',
        fontStyle: isItalics ? 'italic' : 'normal',
        textTransform: isCapsLocks ? 'uppercase' : 'none',
        wordWrap: 'break-word',
        width: `${width * scaleFactor}px`,
        whiteSpace: 'normal',
        overflowWrap: 'anywhere',
        textAlign: 'start',
        color: color ?? '#000000',
        backgroundColor: backgroundColor ?? '#ffffff',
        padding: blockProps?.captionPadding ?? 0,
      }}
    >
      {/* Render HTML content with line breaks and spaces */}
      <div dangerouslySetInnerHTML={{ __html: formattedValue }}></div>
    </div>
  );
};
